module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-raised-button', {
    attrs: {
      "label": "Filters",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.isModalShown = !_vm.isModalShown
      }
    }
  }), _vm._v(" "), _c('mu-dialog', {
    staticClass: "scrollBox",
    attrs: {
      "open": _vm.isModalShown,
      "title": "Refine your search",
      "scrollable": ""
    },
    on: {
      "close": function($event) {
        _vm.isModalShown = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "34px"
    }
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Carbohydrate "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.carbs[0] + ' - ' + _vm.model.carbs[1]) + "g")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.carbs),
      callback: function($$v) {
        _vm.$set(_vm.model, "carbs", $$v)
      },
      expression: "model.carbs"
    }
  }, 'vue-slider', _vm.carbSlider, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Fat "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.fat[0] + ' - ' + _vm.model.fat[1]) + "g")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.fat),
      callback: function($$v) {
        _vm.$set(_vm.model, "fat", $$v)
      },
      expression: "model.fat"
    }
  }, 'vue-slider', _vm.fatSlider, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Calories "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.calories[0] + ' - ' + _vm.model.calories[1]) + "kcal")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.calories),
      callback: function($$v) {
        _vm.$set(_vm.model, "calories", $$v)
      },
      expression: "model.calories"
    }
  }, 'vue-slider', _vm.calorieSlider, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("Protein "), _c('span', {
    staticClass: "floatRight"
  }, [_vm._v(_vm._s(_vm.model.protein[0] + ' - ' + _vm.model.protein[1]) + "g")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    attrs: {
      "speed": 0,
      "start-animation": false
    },
    on: {
      "drag-end": _vm.valuesChanged
    },
    model: {
      value: (_vm.model.protein),
      callback: function($$v) {
        _vm.$set(_vm.model, "protein", $$v)
      },
      expression: "model.protein"
    }
  }, 'vue-slider', _vm.proteinSlider, false))], 1)]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": _vm.$t('message.okText')
    },
    nativeOn: {
      "click": function($event) {
        _vm.isModalShown = false
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98507cbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/MealPlanGenerator/components/meal-plan-filter-modal.vue
// module id = 3819
// module chunks = 1